<header-title [model]="headerTitle"></header-title>

<section class="panel">
    <div class="row mb-3">
        <div class="col col-md-6 align-items-center">
            <button class="btn btn-primary" type="button" [routerLink]="['/company-audit','add']">Add New Audit</button>
        </div>
        <div class="col col-md-6">
            <div class="row align-items-center">
                <div class="col col-md-2 text-end">
                    <label class="control-label">Filter Audits:</label>
                </div>
                <div class="col-md-10">
                    <form [formGroup]="filterForm" *ngIf="filterForm">
                        <input type="text" class="form-control filter-input" formControlName="filterText" placeholder="Start typing to filter list" />
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none dark" *ngIf="companyUserList">
                <thead>
                    <tr>
                        <th>#</th>
                        <th *ngIf="companyUserList.length>1">Company</th>
                        <th>Audit Template</th>
                        <th>Name</th>
                        <th>Start Date</th>
                        <th>Deadline</th>
                        <th>Completed</th>
                        <th>Status</th>
                        <th>External</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let audit of auditList;index as i">
                        <td>{{i+1}}</td>
                        <td *ngIf="companyUserList.length>1">{{audit.companyName}}</td>
                        <td>{{audit.auditTemplateDescription}}</td>
                        <td>{{audit.title}}</td>
                        <td>{{audit.startDate | date: 'dd/MM/yyyy'}}</td>
                        <td>{{audit.deadlineDate | date: 'dd/MM/yyyy'}}</td>
                        <td>{{audit.completedDate | date: 'dd/MM/yyyy'}}</td>
                        <td>
                            <span class="far fa-circle text-primary" *ngIf="audit.auditStatus==0" data-toggle="tooltip" title="Open"></span>
                            <span class="fas fa-circle text-primary" *ngIf="audit.auditStatus==1" data-toggle="tooltip" title="Completed"></span>
                        </td>
                        <td>
                            <span class="fas fa-check text-primary" data-toggle="tooltip" title="External" *ngIf="audit.isExternal"></span>
                        </td>
                        <td class="actions">
                            <a [routerLink]="['/company-audit', audit.id]" class="mb-1 mt-1 mr-2 text-primary"><i class="fas fa-edit"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
